export enum ScanMethod {
  QR = "qr",
  Barcode = "barcode",
}
